import React, { Component } from "react";
import { Card, Container, Row, Col, Collapse } from "react-bootstrap";
import { Box, Text, VStack, Center, Spacer } from "@chakra-ui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartPulse } from "@fortawesome/free-solid-svg-icons";


export default class HealthCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            moreInfoCaret: "caret-down",
            healthColor: "grey",
            currentStatus: "",
            lastRefreshed: "",
            statusMessage: "",
            hasLastProblem: false,
            lastProblemDateTime: "",
            lastProbleMessage: ""
        }

        this.moreInfoToggle = this.moreInfoToggle.bind(this);
    }


    componentDidUpdate(prevProps) {
        if (prevProps.healthInfoTriggerKey !== this.props.healthInfoTriggerKey) {
            if (this.props.healthInfo) {
                var lastRefreshed = this.props.healthInfo?.currentUpdate?.updateDateTime;
                var overallStatus = this.props.healthInfo.overallStatus();
                var healthColor = overallStatus.iconColor;
                var currentStatus = this.props.healthInfo.currentUpdate.updateStatus.label;
                var statusMessage = (this.props.healthInfo.currentUpdate.updateMessages) ? this.props.healthInfo.currentUpdate.updateMessages.join(" ") : "";
                var hasLastProblem = this.props.healthInfo.lastProblemUpdate;
                var lastProblemDateTime = (hasLastProblem) ? this.props.healthInfo.lastProblemUpdate.updateDateTime : "";
                var lastProblemMessage = (hasLastProblem) ?
                    this.props.healthInfo.lastProblemUpdate.updateMessages.join(" ") : "";
                this.setState({
                    lastRefreshed: lastRefreshed,
                    overallStatus: overallStatus,
                    healthColor: healthColor,
                    currentStatus: currentStatus,
                    statusMessage: statusMessage,
                    hasLastProblem: hasLastProblem,
                    lastProblemDateTime: lastProblemDateTime,
                    lastProblemMessage: lastProblemMessage
                });
            }
        }
    }

    moreInfoToggle() {
        var newCaretState = (this.state.moreInfoCaret === "caret-down") ? "caret-up" : "caret-down";
        this.setState({ moreInfoCaret: newCaretState });

    }




    render() {

        const moreInfoSection = () => (
            <VStack>
                <Text>Current Status: {this.state.currentStatus}</Text>
                <Text>Last Updated: {this.state.lastRefreshed}</Text>
                <Text>{this.state.statusMessage}</Text>
                {this.state.hasLastProblem ?
                        <Text>Last Problem: {this.state.lastProblemDateTime}</Text> : "" }
                    {this.state.hasLastProblem ?
                        <Text>Last Problem Status: {this.state.lastProblemMessage}</Text> : "" }
            </VStack>
        )


        const Rule = ({ color }) => (
            <hr
                style={{
                    borderColor: color,
                }}
            />
        );

        const StatusStyle = ({ color, sz, txt }) => (
            <div
                style={{
                    fontColor: color,
                    fontSize: sz
                }}
            >
                {txt}
            </div>
        )




        return (
            <Center style={{ padding: "15px" }}>


                <VStack>
                    <Text>{this.props.title}</Text>
                    <FontAwesomeIcon icon={faHeartPulse} color={this.state.healthColor} size="2x" />
                    <Text>Current Status: {this.state.currentStatus}</Text>
                    <Text>Last Updated: {this.state.lastRefreshed}</Text>
                    <Text>{this.state.statusMessage}</Text>
                    {this.state.hasLastProblem ?
                        <Text>Last Problem: {this.state.lastProblemDateTime}</Text> : "" }
                    {this.state.hasLastProblem ?
                        <Text>Last Problem Status: {this.state.lastProblemMessage}</Text> : "" }
                </VStack>
            </Center>
        );
    }
}
